// GPH Expert Intelligence Core — Video Validation Guard (PDS §12.2).
// Regra absoluta: NUNCA gerar módulo de validação sem vídeo real.
//   - sem vídeo → pedir upload;
//   - com vídeo → associar ao último diagnóstico/treino e usar pipeline Mi real;
//   - pipeline falhou → erro honesto, nunca resultado fabricado.

// Deriva o objetivo de validação a partir do contexto da conversa.
const deriveValidationGoal = (conversationContext) => {
  const diagnosis = conversationContext?.lastDiagnosis;
  const training = conversationContext?.lastTraining;
  if (diagnosis?.symptom) {
    return {
      linkedTo: { type: 'diagnosis', symptom: diagnosis.symptom, at: diagnosis.at },
      validationGoal: `validar ajuste de sensibilidade (sintoma: ${diagnosis.symptom})`,
      capabilityId: 'mi_analysis_aim'
    };
  }
  if (training?.drillGoal || training?.drillId) {
    return {
      linkedTo: { type: 'training', drillId: training.drillId, drillGoal: training.drillGoal, at: training.at },
      validationGoal: `validar execução do treino: ${training.drillGoal || training.drillId}`,
      capabilityId: 'mi_analysis_gameplay'
    };
  }
  return {
    linkedTo: null,
    validationGoal: null,
    capabilityId: null // sem contexto → perguntar objetivo do vídeo
  };
};

export const checkVideoValidation = (conversationContext, hasVideo) => {
  if (!hasVideo) {
    return { canValidate: false, reason: 'video_required', ...deriveValidationGoal(conversationContext) };
  }
  return { canValidate: true, reason: 'ok', ...deriveValidationGoal(conversationContext) };
};

// Trava de renderização: um VideoValidationResult só é renderizável se o
// pipeline processou de verdade (usado pelo Truth Policy e pelos adapters).
export const canRenderValidation = (validationResult) =>
  Boolean(validationResult && validationResult.videoProcessed === true);

const videoValidationGuard = { checkVideoValidation, canRenderValidation };

export default videoValidationGuard;
